import { string } from 'prop-types';
import Color from 'color';
import styled from 'styled-components';

const SIZE = {
  small: '40px',
  medium: '100px',
};

const DashedBoarderCard = styled.div`
  text-align: center;
  padding: ${props => props.theme.space.double};
  height: ${props => SIZE[props.size]};
  padding: 10px;
  background-image:
    linear-gradient(
      to right,
      ${props => Color(props.theme.colors.darkerGrey).lighten(0.3).string()} 50%, transparent 50%
    ),
    linear-gradient(
      to right,
      ${props => Color(props.theme.colors.darkerGrey).lighten(0.3).string()} 50%,
      transparent 50%
    ),
    linear-gradient(
      to bottom,
      ${props => Color(props.theme.colors.darkerGrey).lighten(0.3).string()} 50%,
      transparent 50%
    ),
    linear-gradient(
      to bottom,
      ${props => Color(props.theme.colors.darkerGrey).lighten(0.3).string()} 50%,
      transparent 50%
    );
  background-position: left top, left bottom, left top, right top;
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: 20px 1px, 20px 1px, 1px 20px, 1px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
`;

DashedBoarderCard.propTypes = {
  size: string.isRequired,
};

export default DashedBoarderCard;
